import { IAutoMapper } from "../interfaces";

export const mapAlertItemUsers = (automapper: IAutoMapper): void => {
    automapper
        .createMap("default", "AlertItemUser")
        .forMember("userId", o => o.userId)
        .forMember("first", o => o.first)
        .forMember("last", o => o.last);
};
